import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Chat from './Chat';
import Status from './Status';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Chat />} />
        <Route path="/status" element={<Status />} />
      </Routes>
    </Router>
  );
}

export default App;